import { Controller } from 'stimulus';
import { goToLink } from '../../../../app/javascript/helpers/link_helpers';

export default class extends Controller {
  handleClick(event) {
    goToLink(event);
  }
}
